import { Icon, Layout, Link, Text } from '@loadsmart/miranda-react'

import user from 'legacy/utils/user'

import { type ShipmentTrackingStatus } from '../../domain/Shipment'
import { formatLocationPingEmptyStateTitle } from '../../presenters/trackingPresenter'

export type LocationPingsEmptyStateProps = {
  readonly trackingLink?: string | null
  readonly trackingStatus: ShipmentTrackingStatus
}

export function LocationPingsEmptyState({
  trackingLink,
  trackingStatus,
}: LocationPingsEmptyStateProps) {
  return (
    <Layout.Stack
      align="center"
      justify="center"
      style={{ maxWidth: '240px', textAlign: 'center' }}
    >
      <Icon name="clock" color="color-text-placeholder" size="30px" />
      <Text variant="body-sm-bold" color="color-text-placeholder">
        {formatLocationPingEmptyStateTitle(trackingStatus)}
      </Text>
      {trackingStatus === 'not-tracking' && (
        <>
          {user.isLoggedIn() ? (
            <Text variant="body-sm" color="color-text-placeholder">
              Check the driver and truck information in order to provide tracking
              {trackingLink && (
                <>
                  , or <br />
                  <Link
                    href={trackingLink}
                    size="small"
                    target="_blank"
                    aria-label="open tracking link"
                  >
                    open the external provider
                  </Link>
                </>
              )}
            </Text>
          ) : (
            <Text variant="body-sm" color="color-text-placeholder">
              Check the driver and truck information in order to provide tracking
            </Text>
          )}
        </>
      )}
    </Layout.Stack>
  )
}
